import { Cable, createConsumer } from '@rails/actioncable';
import React, { PropsWithChildren, useEffect, useState } from 'react';
import { CableContext } from './cable-context';

export const CableProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [cable, setCable] = useState<Cable | null>(null);

  useEffect(() => {
    const localCable = createConsumer('/api/cable');

    setCable(localCable);

    return () => {
      localCable.disconnect();
    };
  }, []);

  return (
    <CableContext.Provider value={cable}>{children}</CableContext.Provider>
  );
};
